export const getLoanOptionParams = (loanOptions) => {
  const loanOptionParams = {
    ARM: [],
    Fixed: [],
  };
  loanOptions.forEach((option) => {
    switch (option) {
      case "10Fixed":
        loanOptionParams.Fixed.push("TenYear");
        break;
      case "15Fixed":
        loanOptionParams.Fixed.push("FifteenYear");
        break;
      case "20Fixed":
        loanOptionParams.Fixed.push("TwentyYear");
        break;
      case "30Fixed":
        loanOptionParams.Fixed.push("ThirtyYear");
        break;
      case "ARM56":
        loanOptionParams.ARM.push("FiveYear");
        break;
      case "ARM76":
        loanOptionParams.ARM.push("SevenYear");
        break;
      case "ARM106":
        loanOptionParams.ARM.push("TenYear");
        break;
      default:
        break;
    }
  });
  return loanOptionParams;
};
